import { useQuery } from '@tanstack/react-query';
import useAxios from '../axios';

// get all blogs with token & csr
export const useAllBlogs = params => {
  const instanceWithToken = useAxios();
  return useQuery({
    queryKey: ['getAllBlogs', params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get('blog/all', {
        params,
      });
      return data;
    },
  });
};

// get all blogs without token & ssr
export async function getAllBlogs(params) {
  const queryString = new URLSearchParams(params).toString();
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}blog/all?${queryString}`,
    {
      cache: 'no-store',
    },
  );

  if (!res.ok) throw new Error('Failed to fetch course');
  return res.json();
}
// get blog with token & csr
export const usePublicBlog = params => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ['getPublicBlog', params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get('blog', {
        params,
      });

      return data;
    },
  });
};
// get blog without token & ssr
export async function getBlog(shortId) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_URL}blog?shortId=${shortId}`,
    {
      cache: 'no-store',
    },
  );
  if (!res.ok) throw new Error('Failed to fetch course');
  return res.json();
}

export const useGetBlogSeo = params => {
  const instanceWithToken = useAxios();
  return useQuery({
    queryKey: ['blogSeo', params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get('blog/seo', {
        params,
      });
      return data;
    },
  });
};
